// Supported platform languages. English is the canonical base; the rest are
// AI-translated on demand via the backend pipeline and cached. Adding a new
// language is a one-line addition here + backend LANGUAGES — no other changes.
export const LANGUAGES = [
  { code: "en", name: "English", native: "English", dir: "ltr", locale: "en-US", currency: "USD" },
  { code: "es", name: "Spanish", native: "Español", dir: "ltr", locale: "es-ES", currency: "EUR" },
  { code: "fr", name: "French", native: "Français", dir: "ltr", locale: "fr-FR", currency: "EUR" },
  { code: "de", name: "German", native: "Deutsch", dir: "ltr", locale: "de-DE", currency: "EUR" },
  { code: "pt", name: "Portuguese", native: "Português", dir: "ltr", locale: "pt-BR", currency: "BRL" },
  { code: "it", name: "Italian", native: "Italiano", dir: "ltr", locale: "it-IT", currency: "EUR" },
  { code: "ru", name: "Russian", native: "Русский", dir: "ltr", locale: "ru-RU", currency: "RUB" },
  { code: "zh", name: "Chinese", native: "中文", dir: "ltr", locale: "zh-CN", currency: "CNY" },
  { code: "ja", name: "Japanese", native: "日本語", dir: "ltr", locale: "ja-JP", currency: "JPY" },
  { code: "hi", name: "Hindi", native: "हिन्दी", dir: "ltr", locale: "hi-IN", currency: "INR" },
  { code: "ar", name: "Arabic", native: "العربية", dir: "rtl", locale: "ar-SA", currency: "SAR" },
  { code: "he", name: "Hebrew", native: "עברית", dir: "rtl", locale: "he-IL", currency: "ILS" },
];

export const LANG_CODES = LANGUAGES.map((l) => l.code);
export const RTL_CODES = LANGUAGES.filter((l) => l.dir === "rtl").map((l) => l.code);

export function langMeta(code) {
  return LANGUAGES.find((l) => l.code === code) || LANGUAGES[0];
}
